import DefaultDemandNoteView from "src/components/feature/ProjectDetailView/ViewDemandDraft";

const DemandNoteView = () => {
  return <DefaultDemandNoteView />;
};

export default DemandNoteView;
